import React, {Component} from 'react';

import Layout from '../../components/Layout'
import MyPosts from '../../pages/MyPosts'
import Loading from '../../components/Base/Loading'

/* Container for My Posts page */

class MyPostsContainer extends Component {
	state = {
		isFaculty: false
	};

	componentDidMount() {
		if (localStorage.getItem('isFaculty')) {
			let isFaculty = localStorage.getItem('isFaculty');
			if (isFaculty === 'false') {
				this.setState({isFaculty: false})

			} else {
				this.setState({isFaculty: true})

			}
		}
	}

	render() {
		const { profile} = this.props;

		return (
			<Layout {...this.props} noSideBar>
				{profile === null || profile === undefined ? <Loading/> :
					<MyPosts {...this.props} />}

			</Layout>
		);
	}
}


export default MyPostsContainer;
